<template>
    <div v-if="product" class="sm:w-3/5 px-3  pb-3 content-section--option-data md:w-2/3 w-full">
        <div class="flex  justify-between mb-5">
            <div>
                <ul class="flex gap-2 items-center mb-4" v-if="recipeIndex != -1">
                    <li> {{ recipe?.category }}</li>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                    <li> {{ recipe?.show_name }}</li>
                </ul>
                <h3 v-if="recipeIndex != -1"
                    class="content-section--title text-[#ffc919] text-base leading-4 uppercase font-bold mb-2">
                    {{ recipe?.show_name }}</h3>

                <h3 v-else class="content-section--title text-[#ffc919] text-base leading-4 uppercase font-bold mb-2">
                    {{ getOptionName(recipe) }}</h3>
            </div>
            <div class="w-full max-w-[120px] min-h-[120px] relative" v-if="recipeIndex != -1">
                <img class="max-h-[120px] min-h-[120px] object-cover" v-if="recipe?.photo_store_path"
                    :src="$page.props.storage_image_url + recipe.photo_store_path + '_resize'" :alt="recipe?.show_name || 'Recipe image'">
                <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'"
                    class="max-h-[120px] min-h-[120px] object-cover" :alt="recipe?.show_name || 'Recipe image'">
                <div v-if="$page.props.is_login" class="absolute top-[84px] right-3">
                    <button @click="showPhotoChangePopUp(recipe)"
                        class="text-black bg-white rounded-full w-8 h-8 flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" data-slot="icon" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>


        <h3 :id="'nutritional-info-' + (recipe?.id || 'product')" class="sr-only">Nutritional Information</h3>
        <table v-if="recipe?.total_val" class="w-full h-auto border-collapse focus:ring-2 focus:ring-[#0094cc] outline-none" 
            :tabindex="isActive ? 0 : -1" :aria-labelledby="'nutritional-info-' + (recipe?.id || 'product')">
            <thead class="sr-only">
                <tr>
                    <th scope="col">Nutrient</th>
                    <th scope="col">Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Calories</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.CALS, 'cals') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Sodium</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.SOD, 'mg') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Total Sugar</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.sugar, 'g') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Added Sugars</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.added_sugars, 'g') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Total Fat</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.FAT, 'g') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Saturated Fat</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.satfat, 'g') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Protein</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.PROT, 'g') }}</td>
                </tr>
                <tr class="text-base text-white">
                    <th scope="row" class="font-normal text-left py-1">Carbs</th>
                    <td class="font-light text-right py-1">{{ $helpers.roundTwoDecimals(recipe.total_val.CARB, 'g') }}</td>
                </tr>
            </tbody>
        </table>
        <div class="text-right mt-4">
            <h3 class="w-full text-base uppercase option_title font-bold leading-6 mb-2 xl:text-xl break-all">Allergens:
            </h3>

            <div class="italic xl:text-xl" v-if="recipe?.allergens_name && recipe?.allergens_name != ''">
            <ul class="flex  float-right">
                <li v-if="recipeIndex != -1" v-for="allergen in converAllergensArray(recipe?.allergens_name)">
                    <img width="80" :src="$page.props.asset_url + '/allergens/' + allergen + '.svg'" :title="allergen" :alt="'Contains ' + allergen">
                </li>
            </ul>
            </div>
            <div class="italic xl:text-xl" v-else-if="getAllergensArray().length > 0 && recipeIndex == -1">
            <ul class="flex float-right">
                <li v-for="allergen in getAllergensArray()">
                    <img width="80" :src="$page.props.asset_url + '/allergens/' + allergen + '.svg'" :title="allergen" :alt="'Contains ' + allergen">
                </li>
            </ul>
            </div>

            <p class="italic xl:text-xl" v-else>No allergens specified</p>
        </div>
    </div>
    <ChangePhotoOnFrontRecipe ref="ChangePhotoOnFrontRecipe" :products="recipe" :userLoginCheck="userLoginCheck"
        @closeCalendarPopUp="closePopUp" />
</template>

<script>
var moment = require("moment");
import ChangePhotoOnFrontRecipe from "@/Pages/ParentPortal/Home/ChangePhotoOnFrontRecipe";

export default {
    components: {
        ChangePhotoOnFrontRecipe
    },

    props: ['product', 'recipeIndex', 'userLoginCheck', 'isActive'],
    data() {
        return {
            is_show: false,
            optionImage: "",
        };
    },
    computed: {
        recipe: function () {
            if (this.recipeIndex >= 0) {
                let recipes = this.sortedRecipeArray(this.product.recipes);
                console.log("recipes[this.recipeIndex]", recipes[this.recipeIndex]);
                return recipes[this.recipeIndex];
            } else {
                return this.product;
            }

        }

    },
    methods: {

        converAllergensArray(allergens) {
            if (allergens && allergens != '') {
                return [...new Set(allergens.toLowerCase().split(' , '))];
            } else {
                return [];
            }

        },

        getAllergensArray() {
            let ar = [];
            if (this.product && this.product?.recipes && this.product?.recipes?.length > 0) {
                this.product.recipes.forEach(re => {
                    ar = ar.concat(this.converAllergensArray(re.allergens_name));
                });
            }

            return [...new Set(ar)];
        },

        sortedRecipeArray(recipe_arrays) {
            let a = _.orderBy(recipe_arrays, 'name', 'asc');
            a = _.orderBy(a, 'category_sort', 'asc');
            return a;
        },
        getOptionName(mc) {
            if (mc?.name == '') {
                return "Option " + mc.sort_order;
            } else {
                return mc.name;
            }
        },
        showPhotoChangePopUp(product) {
            this.$refs.ChangePhotoOnFrontRecipe.showPhotoChangePopUp(product);
        },
        closePopUp() {
            this.is_show = false;
        }
    },
};
</script>
<style>
.content-section--option-data {
    color: #fff;
}
</style>